<template>
  <div
    class="sy-address"
    :class="{
      'sy-address-mini': size === 'mini',
      'sy-address-show-info': addressDetail && addressDetail.id
    }"
  >
    <div class="address-info">
      <template v-if="showAddressInfoText">
        <slot>
          <span v-if="addressDetail && addressDetail.id" class="address-content" :title="addressInfo" >
            <span>{{addressDetail.provinceName + addressDetail.cityName + addressDetail.countyName + addressDetail.townName + addressDetail.addressInfo || ''}}</span>
            <template>
              <span class="ml10" v-if="showPerson">{{addressDetail.goodsName || addressDetail.name}}</span>
              <span class="ml10" v-if="showPerson">{{pageText.collect}}</span>
              <span class="ml10" v-if="showPerson">{{addressDetail.goodsPhone || addressDetail.mobile}}</span>
            </template>
          </span>
        </slot>
      </template>
      <slot v-else></slot>
    </div>
    <div class="sy-address-handler-wrap">
      <span
        v-if="allowAddressList"
        class="sy-address-select-handle"
        :class="[disabled ? 'sy-address-select-handle-disabled' : 'font-color-link']"
        @click="handleSelectMoreAddress"
      >{{pageText.selectAddress}}</span>
    </div>
    <SyAddressList
      ref="syAddressList"
      v-bind="$attrs"
      :showPerson="showPerson"
      :addressApi="api"
      :addressId="id"
      @addressChange="addressChange"
    ></SyAddressList>
  </div>
</template>

<script>
import SyAddressList from './address-list.vue'
import addressApi from './api'

import i18n from './i18n'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'sy-address',
  props: {
    size: {type: String, default: 'small'},
    // 是否显示地址信息
    showAddressInfoText: {type: Boolean, default: true},

    // 是否显示联系人
    showPerson: {type: Boolean, default: true},

    // 是否显示 选择地址
    allowAddressList: {type: Boolean, default: true},
    // 默认显示的地址信息
    defaultAddressDetail: {type: Object, default: () => ({})},
    api: {type: Object, default: addressApi},
    id: {type: Number},
    // 禁用
    disabled: {type: Boolean, default: false}
  },
  components: {
    SyAddressList
  },
  data () {
    return {
      pageText,
      addressDetail: this.defaultAddressDetail,
      editAddressDetail: null
    }
  },
  watch: {
    defaultAddressDetail: {
      handler (val) {
        if (val) {
          this.addressDetail = val
        }
      },
      immediate: false
    }
  },
  computed: {
    addressInfo () {
      if (!this.addressDetail) return ''

      const v = this.addressDetail

      const areaStr =  `${v.provinceName} ${v.cityName} ${v.countyName} ${v.townName || ''}`
      let addressStr = v.addressInfo
      if (this.showPerson) {
        addressStr += ` ${this.addressDetail.goodsName || v.name} ${this.pageText.collect} ${this.addressDetail.goodsPhone || v.mobile}`
      }
      return areaStr + addressStr
    }
  },
  methods: {
    // 选择地址
    handleSelectMoreAddress () {
      if (this.disabled) return
      this.$refs['syAddressList']._toggle()
    },
    addressChange (address) {
      if (!address) {
        return false
      }
      // 新增编辑返回是不包含名称，需要重新调取详情接口
      if (address.provinceName && address.cityName && address.countyName) {
        this.addressDetail = address
        this.addressId =  address.id
        this.editAddressDetail = null
        this.$emit('update:id', address.id)
        this.$emit('addressChange', address, this.groupIndex, this.lineIndex)
      }
    }
  }
}
</script>

<style scoped lang="scss">
// normal
.sy-address {
  font-size: 14px;
  .address-info {
    line-height: 20px;
  }
  .sy-address-handler-wrap {
    .sy-address-select-handle {
      font-size: 14px;
    }
  }
}
// mini
.sy-address-mini {
  font-size: 12px;
  line-height: 28px;
  .sy-address-handler-wrap {
    height: 28px;
    line-height: 28px;
    .sy-address-select-handle {
      font-size: 12px;
    }
  }
}

.sy-address-select-handle-disabled {
  color: #bbb;
  cursor: not-allowed;
}
// 显示地址信息
.sy-address-show-info {
  &.sy-address-mini {
    .address-info {
      padding: 4px 0;
    }
  }
  .address-info {
    padding-bottom: 6px;
  }
  .sy-address-handler-wrap {
    line-height: 1;
    height: auto;
  }
}
</style>
